import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRICE_TODAY } from '../constants/data';
const trust = [{
  icon: FileTextIcon,
  label: 'Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Solo Mercado Pago'
}];
const stats = [{
  value: '+500',
  label: 'jóvenes'
}, {
  value: '10',
  label: 'productos'
}, {
  value: '4.9/5 ⭐',
  label: 'valoración'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
export function Hero() {
  return <section className="relative w-full overflow-hidden px-5 pt-12 pb-16 sm:pt-20 sm:pb-24" style={{
    background: 'linear-gradient(160deg, #0A0A0A 0%, #050B18 100%)'
  }} data-id="element-164">
      <div className="mx-auto max-w-4xl flex flex-col items-center text-center" data-id="element-165">
        <motion.span initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.25em] text-white/70" data-id="element-166">
          Cherub Agency
          <span style={{
          color: '#00C853'
        }} data-id="element-167">
            ™
          </span>
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight" data-id="element-168">
          MEGAPACK: FINANZAS
          <br className="hidden sm:block" data-id="element-169" /> PARA JÓVENES™
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-4 text-xl sm:text-2xl font-semibold" style={{
        color: '#00C853'
      }} data-id="element-170">
          El sistema completo para tomar el control de tu guita
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-8 w-full max-w-3xl px-4" data-id="element-171">
          <img src="https://cdn.magicpatterns.com/uploads/7syqbTvLRLBn23CYojVcCB/828356ed-89b2-48bf-841b-8dbbb540e25b_(1).png" alt="Megapack Finanzas para Jóvenes Bundle" className="w-full h-auto drop-shadow-[0_0_30px_rgba(0,200,83,0.2)]" data-id="element-172" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-8 max-w-2xl text-base sm:text-lg text-white/70" data-id="element-173">
          Control + Protección + Ahorro + Inversión + Más Ingresos. Todo en un
          lugar. Sin depender de gurús.
        </motion.p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-174">
          {trust.map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex items-center gap-2 text-sm text-white/80" data-id="element-175">
              <Icon className="w-4 h-4" style={{
            color: '#00C853'
          }} aria-hidden="true" data-id="element-176" />
              <span data-id="element-177">{label}</span>
            </div>)}
        </div>

        <div className="mt-9 w-full max-w-md" data-id="element-178">
          <CTAButton label={`QUIERO MI MEGAPACK AHORA — ${PRICE_TODAY}`} showSecureText={false} href="#oferta" data-id="element-179" />
          <p className="mt-3 text-xs sm:text-sm text-neutral-400" data-id="element-180">
            Acceso inmediato al pagar · Garantía 7 días sin preguntas
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-3 w-full max-w-2xl" data-id="element-181">
          {stats.map(s => <div key={s.label} className="glass px-3 py-4 flex flex-col items-center" data-id="element-182">
              <span className="text-xl sm:text-2xl font-bold" style={{
            color: '#00C853'
          }} data-id="element-183">
                {s.value}
              </span>
              <span className="mt-1 text-xs text-white/60" data-id="element-184">{s.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}